export default {
	active_campaigns: "Campagnes actives",
	begin_date: "Date de Début",
	campaign: "Campagne",
	end_date: "Date du Terme",
	learn_more_about_the_campaign_by_clicking: "En savoir plus sur la campagne en cliquant sur",
	no_campaigns_found: "Aucune campagne trouvée",
	previous_campaigns: "Campagnes précédentes",
	view_campaign: "Voir la Campagne",
}